module.exports = __webpack_public_path__ + "img/100yil-logo.e6063058.png";